export default (function (obj) {
  var str = [];
  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }return str.join('&');
});


//////////////////
// WEBPACK FOOTER
// ./plugins/serialize.js
// module id = ./plugins/serialize.js
// module chunks = 0